import React, { useRef, useState } from "react";
import { getDvSourceImageUrl } from "../../../functions/themeAssets";
import { POPUP_IMAGE_DIMENSION_LABEL } from "./popupImageUpload";

export const POPUP_TEXT_MAX_LEN = 80;

function PopupField({ title, placeholder, savedImage, savedText, onSubmit, isSaving }) {
  const fileInputRef = useRef(null);
  const [draftText, setDraftText] = useState("");
  const [file, setFile] = useState(null);
  const [localError, setLocalError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
    setLocalError("");
  };

  const handleSubmit = async () => {
    const trimmed = draftText.trim();
    if (trimmed && file) {
      setLocalError("You can only submit either text or an image — not both.");
      return;
    }
    if (!trimmed && !file) {
      setLocalError("Enter popup text or choose an image before submitting.");
      return;
    }
    setLocalError("");
    await onSubmit({ text: trimmed, file });
    setDraftText("");
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <div className="popup-form">
      <h4 className="popup-form-title">{title}</h4>

      <textarea
        className="popup-form-textarea"
        rows={3}
        maxLength={POPUP_TEXT_MAX_LEN}
        value={draftText}
        placeholder={placeholder}
        onChange={(e) => setDraftText(e.target.value.replace(/^\s+/, ""))}
      />
      <p className="popup-hint">
        * Maximum character limit should be {POPUP_TEXT_MAX_LEN} characters.
      </p>

      <div className="popup-or-text">Or</div>

      <input
        ref={fileInputRef}
        type="file"
        className="popup-file-native"
        accept="image/jpeg,image/png,image/gif"
        onChange={handleFileChange}
      />
      <p className="popup-hint">
        * Popup image dimensions must be {POPUP_IMAGE_DIMENSION_LABEL.replace("x", " x ")}.
      </p>
      <p className="popup-hint">* Allowed photo formats: JPG, JPEG, PNG, and GIF.</p>

      {localError ? <p className="cr-alert cr-alert-error">{localError}</p> : null}

      <button
        type="button"
        className="popup-submit-btn"
        onClick={handleSubmit}
        disabled={isSaving}
      >
        {isSaving ? "Submitting…" : "Submit"}
      </button>

      <h4 className="popup-form-title popup-preview-title">Preview Section</h4>
      <div className="popup-preview">
        {savedImage ? (
          <img src={getDvSourceImageUrl(savedImage)} alt="" />
        ) : savedText ? (
          <p className="popup-preview-text">{savedText}</p>
        ) : (
          <span className="no-img-text">No preview yet</span>
        )}
      </div>
    </div>
  );
}

export default function PopupTab({
  correctAnsText,
  correctAnsImage,
  endGameText,
  endGameImage,
  onSubmitCorrect,
  onSubmitEndGame,
  isSavingCorrect,
  isSavingEndGame,
  errorMessage,
  successMessage,
}) {
  return (
    <div className="themeupdate-panel-wide">
      {(errorMessage || successMessage) && (
        <div className="qa-alerts">
          {errorMessage ? <p className="cr-alert cr-alert-error">{errorMessage}</p> : null}
          {successMessage ? <p className="cr-alert cr-alert-success">{successMessage}</p> : null}
        </div>
      )}

      <div className="popup-columns">
        <PopupField
          title="Add Correct Answer Popup"
          placeholder="Enter Text For Correct Answer Pop Up"
          savedImage={correctAnsImage}
          savedText={correctAnsText}
          onSubmit={onSubmitCorrect}
          isSaving={isSavingCorrect}
        />
        <PopupField
          title="Add end game Popup"
          placeholder="Enter Text For end game Pop Up"
          savedImage={endGameImage}
          savedText={endGameText}
          onSubmit={onSubmitEndGame}
          isSaving={isSavingEndGame}
        />
      </div>
    </div>
  );
}
